const secureBackendApiDomains = {
  production: 'https://secure-backend-api.stilingue.com.br/',
  staging: 'https://secure-backend-api-staging.stilingue.com.br/',
};

export default secureBackendApiDomains;
